module.exports = __webpack_public_path__ + "static/media/camera.0726b97f.svg";